import api from "../api";

export const getRoles = (params) =>
  api.get("/role", { params });

export const addRole = (payload) => api.post("/role/add", payload);

export const updateRole = (id, payload) =>
  api.post(`/role/edit/${id}`, payload);

export const deleteRole = (id) =>
  api.post(`/role/delete/${id}`);

export const changeRoleStatus = (id, active) =>
  api.post(`/role/change_status/${id}`, { active });

